import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "is-flex-grow-1 is-flex is-align-items-center gap-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "has-text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_job_status = _resolveComponent("job-status")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "is-flex gap-3",
    to: { name: _ctx.detailView, params: { jobId: _ctx.job.clientPath } },
    title: "Details"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_job_status, { job: _ctx.job }, null, 8, ["job"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.job.name), 1),
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.createdDate), 1)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_component_o_icon, { icon: "chevron-right" })
    ]),
    _: 3
  }, 8, ["to"]))
}